export default __webpack_public_path__ + "static/media/battlefieldcommander.d00be58d.png";